/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Os_One_SizeInputs */

const en_val_os_one_size = /** @type {(inputs: Val_Os_One_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OS (One Size)`)
};

const es_val_os_one_size = /** @type {(inputs: Val_Os_One_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talla única (OS)`)
};

const fr_val_os_one_size = /** @type {(inputs: Val_Os_One_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille unique (OS)`)
};

const de_val_os_one_size = /** @type {(inputs: Val_Os_One_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OS (Einheitsgröße)`)
};

const ja_val_os_one_size = /** @type {(inputs: Val_Os_One_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OS (ワンサイズ)`)
};

const zh_val_os_one_size = /** @type {(inputs: Val_Os_One_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OS (均码)`)
};

const ar_val_os_one_size = /** @type {(inputs: Val_Os_One_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مقاس واحد (OS)`)
};

const id_val_os_one_size = /** @type {(inputs: Val_Os_One_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OS (Satu Ukuran)`)
};

const it_val_os_one_size = /** @type {(inputs: Val_Os_One_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taglia Unica (OS)`)
};

const ru_val_os_one_size = /** @type {(inputs: Val_Os_One_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OS (Единый размер)`)
};

const pt_val_os_one_size = /** @type {(inputs: Val_Os_One_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho Único`)
};

const ko_val_os_one_size = /** @type {(inputs: Val_Os_One_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OS (프리사이즈)`)
};

/**
* | output |
* | --- |
* | "OS (One Size)" |
*
* @param {Val_Os_One_SizeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_os_one_size = /** @type {((inputs?: Val_Os_One_SizeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Os_One_SizeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_os_one_size(inputs)
	if (locale === "es") return es_val_os_one_size(inputs)
	if (locale === "fr") return fr_val_os_one_size(inputs)
	if (locale === "de") return de_val_os_one_size(inputs)
	if (locale === "ja") return ja_val_os_one_size(inputs)
	if (locale === "zh") return zh_val_os_one_size(inputs)
	if (locale === "ar") return ar_val_os_one_size(inputs)
	if (locale === "id") return id_val_os_one_size(inputs)
	if (locale === "it") return it_val_os_one_size(inputs)
	if (locale === "ru") return ru_val_os_one_size(inputs)
	if (locale === "pt") return pt_val_os_one_size(inputs)
	return ko_val_os_one_size(inputs)
});